import { get } from "../../request";
import type { Search } from "../../../Search";

type Params = {
  feedId: string;
};
type Response = {
  data: Search;
};

/**
 * @name GrailedAPI.v1.Searches.getSearch
 * @param {Params} params
 * @param {string} params.feedId - the uuid of the requested search
 * @return {Promise<Response>} a promise that resolves with a response containing the new search
 */
const getSearch = (params: Params): Promise<Response> =>
  get(`/api/searches/${params.feedId}`);

export default getSearch;
